import createWithBsPrefix from './utils/createWithBsPrefix';
import divWithClassName from './utils/divWithClassName';
var DivStyledAsH4 = divWithClassName('h4');
export default createWithBsPrefix('modal-title', {
  Component: DivStyledAsH4
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/es/ModalTitle.js
// module id = 416
// module chunks = 0